import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useWhatsappNumber } from "../hooks/use-whatsapp-number";

export function WhatsappNumberConfig() {
  const { value, setValue, loading, saving, save } = useWhatsappNumber();

  return (
    <div className="space-y-2">
      <Label htmlFor="whatsapp-number">Customer WhatsApp number</Label>
      <p className="text-sm text-muted-foreground">
        Shown as a WhatsApp button on your storefront (for example while online booking is paused).
        Include the country code, e.g. +1 415 555 2671.
      </p>
      <div className="flex items-center gap-2">
        <Input
          id="whatsapp-number"
          type="tel"
          inputMode="tel"
          placeholder="+1 415 555 2671"
          value={value}
          disabled={loading}
          onChange={(event) => setValue(event.target.value)}
        />
        <Button onClick={save} disabled={saving || loading}>
          {saving ? "Saving…" : "Save"}
        </Button>
      </div>
    </div>
  );
}
